import React from 'react';
import { ModalFuncProps, Radio } from 'antd';

export type OrderPdfConversionUnit = 'm2' | 'm3';

type ConfirmModal = {
  confirm: (config: ModalFuncProps) => void;
};

type Translate = (key: string) => string;

export function promptOrderPdfConversionUnit(
  modal: ConfirmModal,
  t: Translate,
): Promise<OrderPdfConversionUnit | null> {
  return new Promise<OrderPdfConversionUnit | null>((resolve) => {
    let selectedUnit: OrderPdfConversionUnit = 'm2';
    modal.confirm({
      title: t('orders:orderDetail.additionalDimensionPrompt'),
      content: (
        <Radio.Group
          defaultValue={selectedUnit}
          onChange={(event) => {
            selectedUnit = event.target.value as OrderPdfConversionUnit;
          }}
          optionType="button"
          buttonStyle="solid"
          style={{ marginTop: 8 }}
        >
          <Radio.Button value="m2">m²</Radio.Button>
          <Radio.Button value="m3">m³</Radio.Button>
        </Radio.Group>
      ),
      okText: t('orders:orderDetail.additionalDimensionDownload'),
      cancelText: t('common:cancel'),
      onOk: () => resolve(selectedUnit),
      onCancel: () => resolve(null),
    });
  });
}
